import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../components/molecules/Header/Header";
import Footer from "../../components/molecules/Footer/Footer";
import { NotifyType } from "../../utils/NotifyType";
import { notify } from "../../utils";
import Loader from "../../components/molecules/Loader";
import { getAllPaymentHistory } from "../../api/apimethods";
import PaymentGrid from "./PaymentGrid";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const PaymentDashboard = () => {
  const enquiryDashboard = [
    {
      columnName: "S.No",
      sortKey: "SNo",
    },
    {
      columnName: "Reference Number",
      sortKey: "referenceNumber",
    },
    {
      columnName: " Transaction Number",
      sortKey: "transactionNumber",
    },
    {
      columnName: "Payment Amount",
      sortKey: "paymentAmount",
    },
    {
      columnName: "Payment Date",
      sortKey: "paymentDate",
    },
    {
      columnName: "Payment Mode",
      sortKey: "paymentType",
    },
    {
      columnName: "Payment Status",
      sortKey: "paymentstatusText",
    },
    {
      columnName: "Action",
      sortKey: "",
    },
  ];

  const [data, setData] = useState<any[]>([]);
  const { message } = notify();
  const navigate = useNavigate();
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [showError, setShowError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showGrid, setShowGrid] = useState(false);
  const [referenceError, setreferenceError] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [headers, setHeaders] = useState<any[]>(enquiryDashboard);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [referenceNumber, setReferenceNumber] = useState<string | null>(null);
  const [transactionNumber, settransactionNumber] = useState<string | null>(
    null
  );
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  const handleReset = () => {
    setShowGrid(false);
    setDateFrom("");
    setDateTo("");
    setShowError(false);
    setReferenceNumber("");
    settransactionNumber("");
    setData([]);
  };

  const getNextDay = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate());
    return newDate.toISOString().split("T")[0];
  };

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };
  useEffect(() => {
    const fetchDefaultData = async () => {
      try {
        setPageLoading(true);

        const getUserInfo = localStorage.getItem("app-data");
        const userInfo = JSON.parse(getUserInfo || "{}");
        const NRIC = userInfo?.user?.idNo || "";

        const responses = await getAllPaymentHistory(
          NRIC,
          null,
          null,
          null,
          null
        );

        setData(responses.data);
        setShowGrid(responses.data.length > 0);

        if (responses.data.length === 0) {
          message(NotifyType.Info, "No payment history found");
        }
      } catch (error) {
        console.error("Failed to fetch payment history:", error);
        message(NotifyType.Error, "Failed to load payment history");
      } finally {
        setPageLoading(false);
      }
    };

    fetchDefaultData();
  }, []);
  const handleSearch = async () => {
    try {
      if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
        message(NotifyType.Error, "Please enter both From and To dates");
        setShowError(true);
        return;
      }

      setSearchLoading(true);
      setShowError(false);

      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "{}");
      const NRIC = userInfo?.user?.idNo || "";
      setCurrentPage(1);
      setPageLoading(true);

      const responses = await getAllPaymentHistory(
        NRIC,
        referenceNumber || null,
        transactionNumber || null,
        dateFrom || null,
        dateTo || null
      );

      setData(responses.data);
      setShowGrid(responses.data.length > 0);

      if (responses.data.length === 0) {
        message(NotifyType.Info, "No Application(s) found");
      }

      setSearchLoading(false);
      setPageLoading(false);
    } catch (error) {
      console.error("Search error:", error);
      setSearchLoading(false);
      setPageLoading(false);
      message(NotifyType.Error, "Failed to fetch payment history");
    }
  };

  return (
    <>
      <Header />
      <center>
        <h3 className="savedraft">Payment Receipt Dashboard</h3>
      </center>
      <Container>
        <form>
          <div className="row">
            <div className="col-lg-12">
              <div className="col-md-11">
                <div className="info-content">
                  <div className="row mb-3">
                    <div className="col-lg-3">
                      <label className="col-form-label">Registered Date</label>
                    </div>
                    <div className="col-lg-1">
                      <label className="col-form-label">From</label>
                    </div>
                    <div className="col-lg-3">
                      <input
                        type="date"
                        value={dateFrom}
                        className="form-control"
                        max={getTodayDate()}
                        onChange={(e) => {
                          setDateFrom(e.target.value);
                          setDateTo("");
                          setShowError(false);
                        }}
                        required
                      />
                    </div>
                    <div className="col-lg-1">
                      <label className="col-form-label">To</label>
                    </div>
                    <div className="col-lg-3">
                      <input
                        type="date"
                        value={dateTo}
                        className="form-control"
                        onChange={(e) => {
                          setDateTo(e.target.value);
                          setShowError(false);
                        }}
                        min={dateFrom ? getNextDay(dateFrom) : ""}
                        max={getTodayDate()}
                        required
                      />
                    </div>
                  </div>

                  {showError && (
                    <div className="row mb-3">
                      <div className="col-lg-3"></div>
                      <div className="col-lg-9 text-danger">
                        Please enter both From and To dates
                      </div>
                    </div>
                  )}

                  <div className="row mb-3">
                    <div className="col-lg-3">
                      <label className="col-form-label">Reference Number</label>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        value={referenceNumber || ""}
                        onChange={(e) => {
                          setReferenceNumber(e.target.value);
                          setreferenceError(false);
                        }}
                        required
                      />
                      {referenceError && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please fill Reference Number.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-lg-3">
                      <label className="col-form-label">
                        Transaction Number
                      </label>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        value={transactionNumber || ""}
                        onChange={(e) => settransactionNumber(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className={`custom-search-button ${
                          searchLoading ? "loading" : ""
                        }`}
                        onClick={handleSearch}
                        disabled={searchLoading}
                      >
                        {searchLoading ? "Searching..." : "Search"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="mt-3">
          <br />
          {pageLoading ? <Loader /> : null}
          {showGrid && data.length > 0 && (
            <PaymentGrid
              data={data}
              isLoading={isLoading}
              headerColumns={headers}
              setData={setData}
            />
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default PaymentDashboard;
